import Abrechnung from '@/classes/Abrechnung/abrechnung'
import AbrechnungenLoader from '@/classes/Helper/abrechnungenLoader'
import { where, getDocs, getFirestore, collection } from 'firebase/firestore'
import md5 from 'md5'

const AbrechnungModule = {
  namespaced: true,
  state: {
    current_abrechnungen: [],
    current_abrechnung: null,
    current_tab: -1, // -1 = nicht initialisiert
    loading: false,
    abrechnungenLoader: null,
    searchLoader: null,
    mode: '',
    user_filter: {

    },
    filter: {
      abteilung: { name: 'Alle', type: 'Alle' },
      ausschuss: { name: 'Alle', type: 'Alle', refId: 'Alle' },
      jahr: []
    },
    selected_sort: { text: 'Datum', value: 1, short: 'Datum' },
    filter_values: {
      abteilung: [
        {
          text: 'Alle',
          value: { type: 'Alle', name: 'Alle' }
        }
      ],
      ausschuesse: [
        {
          text: 'Alle',
          value: { type: 'Alle', refId: 'Alle', name: 'Alle' }
        }
      ],
      jahr: []
    },
    hauptamt: [],
    ehrenamt: [],
    user: null, // Wird von außen gesetzt, z.B. beim Laden der Abrechnungen
  },
  getters: {
    currentAbrechnungen(state) {
      return state.current_abrechnungen
    },
    currentAbrechnung(state) {
      return state.current_abrechnung
    },
    currentTab(state) {
      return state.current_tab
    },
    loading(state) {
      return state.loading
    },
    filter(state) {
      return state.filter
    },
    filterValues(state) {
      return state.filter_values
    },
    selectedSort(state) {
      return state.selected_sort
    },
    currentStatus(state) {
      // FLVW-Modus: Tab 0=Offen, Tab 1=Genehmigt, Tab 2=Abgeschlossen
      // Kreis-Modus: Tab 0=Eingereicht, Tab 1=Offen, Tab 2=Genehmigt, Tab 3=Abgeschlossen
      if (state.current_tab === -1) return '' // Noch nicht initialisiert

      if (state.mode === 'FLVW') {
        if (state.current_tab == 0) return 'Offen'
        if (state.current_tab == 1) return 'Genehmigt'
        if (state.current_tab == 2) return 'Abgeschlossen'
      } else if (state.mode === 'Kreis') {
        if (state.current_tab == 0) return 'Eingereicht'
        if (state.current_tab == 1) return 'Offen'
        if (state.current_tab == 2) return 'Genehmigt'
        if (state.current_tab == 3) return 'Abgeschlossen'
      }
      return ''
    },
    currentStatusDisplayName(state) {
      // FLVW-Modus: Tab 0=Offen, Tab 1=Genehmigt, Tab 2=Abgeschlossen
      // Kreis-Modus: Tab 0=Eingereicht, Tab 1=Offen, Tab 2=Genehmigt, Tab 3=Abgeschlossen
      if (state.current_tab === -1) return '' // Noch nicht initialisiert

      if (state.mode === 'FLVW') {
        if (state.current_tab == 0) return 'Offen'
        if (state.current_tab == 1) return 'Genehmigt'
        if (state.current_tab == 2) return 'Abgeschlossen'
      } else if (state.mode === 'Kreis') {
        if (state.current_tab == 0) return 'Eingereicht'
        if (state.current_tab == 1) return 'Offen'
        if (state.current_tab == 2) return 'Genehmigt'
        if (state.current_tab == 3) return 'Abgeschlossen'
      }
      return ''
    },
    filterSet(state) {
      const currentYear = new Date().getFullYear().toString()
      return !(state.filter.abteilung.type == 'Alle' &&
        ((state.current_tab == 3 && state.filter.jahr.length == 1) ||
          (state.current_tab < 3 && state.filter.jahr.length > 1)))
    },
    abrechnungenSortiert(state) {
      const abrechnungen = [...state.current_abrechnungen]
      if (state.selected_sort.value == 1) {
        abrechnungen.sort((a, b) => b.versionId - a.versionId)
      }
      if (state.selected_sort.value == 2) {
        abrechnungen.sort((a, b) => a.versionId - b.versionId)
      }
      if (state.selected_sort.value == 3) {
        abrechnungen.sort((a, b) => a.abrechnender.nachname.localeCompare(b.abrechnender.nachname))
      }
      if (state.selected_sort.value == 4) {
        abrechnungen.sort((b, a) => a.abrechnender.nachname.localeCompare(b.abrechnender.nachname))
      }
      if (state.selected_sort.value == 5) {
        abrechnungen.sort((a, b) => a.empfaenger.name.localeCompare(b.empfaenger.name))
      }
      if (state.selected_sort.value == 6) {
        abrechnungen.sort((b, a) => a.empfaenger.name.localeCompare(b.empfaenger.name))
      }
      return abrechnungen
    },
    nextAbrechnung(state) {
      if (!state.current_abrechnung || !state.current_abrechnung.id || !state.current_abrechnungen || !state.current_abrechnungen.length) {
        return null;
      }

      const currentIndex = state.current_abrechnungen.findIndex(
        abrechnung => abrechnung && abrechnung.id === state.current_abrechnung.id
      );

      if (currentIndex === -1 || currentIndex === state.current_abrechnungen.length - 1) {
        return null; // Aktuelle Abrechnung nicht gefunden oder ist bereits die letzte
      }

      return state.current_abrechnungen[currentIndex + 1];
    },
    prevAbrechnung(state) {
      if (!state.current_abrechnung || !state.current_abrechnung.id || !state.current_abrechnungen || !state.current_abrechnungen.length) {
        return null;
      }

      const currentIndex = state.current_abrechnungen.findIndex(
        abrechnung => abrechnung && abrechnung.id === state.current_abrechnung.id
      );

      if (currentIndex === -1 || currentIndex === 0) {
        return null; // Aktuelle Abrechnung nicht gefunden oder ist bereits die erste
      }

      return state.current_abrechnungen[currentIndex - 1];
    },
    hauptamt(state) {
      return state.hauptamt
    },
    ehrenamt(state) {
      return state.ehrenamt
    }
  },

  mutations: {
    NEUE_AUSLAGENABRECHNUNG(state) {
      state.auslagenabrechnung = new Abrechnung()
    },
    SET_CURRENT_ABRECHNUNGEN(state, abrechnungen) {
      state.current_abrechnungen = abrechnungen
    },
    SET_CURRENT_ABRECHNUNG(state, abrechnung) {
      state.current_abrechnung = abrechnung
    },
    SET_CURRENT_TAB(state, tab) {
      state.current_tab = tab
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_MODE(state, mode) {
      state.mode = mode
    },
    SET_FILTER(state, filter) {
      state.filter = { ...state.filter, ...filter }
    },
    SET_FILTER_VALUES(state, filterValues) {
      state.filter_values = { ...state.filter_values, ...filterValues }
    },
    SET_SELECTED_SORT(state, sort) {
      state.selected_sort = sort
    },
    SET_ABRECHNUNGEN_LOADER(state, loader) {
      state.abrechnungenLoader = loader
    },
    SET_SEARCH_LOADER(state, loader) {
      state.searchLoader = loader
    },
    RESET_FILTER(state) {
      const currentYear = new Date().getFullYear().toString()
      // Begrenze Jahre auf maximal 3 um Disjunktionen-Limit einzuhalten
      const maxJahre = state.current_tab < 3 ? 
        state.filter_values.jahr.slice(-3) : // Nur die letzten 3 Jahre
        [state.filter_values.jahr[state.filter_values.jahr.length - 1]] // Nur aktuelles Jahr
      
      state.filter = {
        abteilung: { name: 'Alle', type: 'Alle' },
        ausschuss: { name: 'Alle', type: 'Alle', refId: 'Alle' },
        jahr: maxJahre
      }
    },
    ADD_MORE_ABRECHNUNGEN(state, abrechnungen) {
      state.current_abrechnungen = state.current_abrechnungen.concat(abrechnungen)
    },
    RESET_HAUPTAMT(state) {
      state.hauptamt = []
    },
    RESET_EHRENAMT(state) {
      state.ehrenamt = []
    },
    ADD_HAUPTAMT(state, data) {
      state.hauptamt.push(data)
      state.hauptamt.sort((a, b) => a.name < b.name ? -1 : 1)
    },
    ADD_EHRENAMT(state, data) {
      state.ehrenamt.push(data)
      state.ehrenamt.sort((a, b) => a.name < b.name ? -1 : 1)
    },
    SET_USER(state, user) {
      state.user = user
    }
  },
  actions: {
    async newAbrechnung({ commit }) {
      commit('NEUE_AUSLAGENABRECHNUNG')
    },
    async initializeAbrechnungen({ commit, dispatch, state, rootGetters }, { mode, user }) {
      commit('SET_MODE', mode)
      commit('SET_USER', user)
      // Daten laden falls noch nicht vorhanden
      if (state.hauptamt.length === 0) {
        const hauptamt = await getDocs(collection(getFirestore(), 'Hauptamt'))
        commit('RESET_HAUPTAMT')
        hauptamt.forEach(amt => {
          commit('ADD_HAUPTAMT', {
            id: amt.id,
            name: amt.data().name,
            ansprechpartner: amt.data().ansprechpartner
          })
        })
      }

      if (state.ehrenamt.length === 0) {
        const ehrenamt = await getDocs(collection(getFirestore(), 'Ehrenamt'))
        commit('RESET_EHRENAMT')
        ehrenamt.forEach(amt => {
          commit('ADD_EHRENAMT', {
            id: amt.id,
            name: amt.data().name,
            abteilungen: amt.data().abteilungen || []
          })
        })
      }

      // Filter-Werte initialisieren
      const filterValues = {
        abteilung: [{ text: 'Alle', value: { type: 'Alle', name: 'Alle' } }],
        ausschuesse: [{ text: 'Alle', value: { type: 'Alle', refId: 'Alle', name: 'Alle' } }],
        jahr: []
      }

      if (mode == 'FLVW') {

        if (state.hauptamt && Array.isArray(state.hauptamt)) {
          state.hauptamt.forEach(item => {
            if (!item.name) return
            filterValues.abteilung.push({
              text: item.name + ' (Hauptamt)',
              value: { type: 'Hauptamt', name: item.name }
            })
          })
        }

        if (state.ehrenamt && Array.isArray(state.ehrenamt)) {
          state.ehrenamt.forEach(item => {
            filterValues.abteilung.push({
              text: item.name + ' (Gremium)',
              value: { type: 'Gremium', name: item.name }
            })
          })
        }
      } else if (mode == 'Kreis' && (user.kv() || user.kk())) {
        const kreise = rootGetters.kreise
        if (kreise && kreise.kreise && Array.isArray(kreise.kreise)) {
          const kreis = kreise.kreise.find(item => item.id == user.kreis)
          if (kreis && kreis.ausschuesse && Array.isArray(kreis.ausschuesse)) {
            kreis.ausschuesse.forEach(item => {
              filterValues.ausschuesse.push({
                text: item.name,
                value: { type: 'Kreis-Ausschuss', name: item.name, refId: item.id }
              })
            })
          }
        }
      }

      // Jahre seit 2023
      const startYear = 2023
      const currentYear = new Date().getFullYear()
      for (let year = startYear; year <= currentYear; year++) {
        filterValues.jahr.push(year.toString())
      }

      commit('SET_FILTER_VALUES', filterValues)

      // Standard-Tabs setzen nur bei erster Initialisierung
      if (state.current_tab === -1) {
        if (mode == 'FLVW') {
          commit('SET_CURRENT_TAB', 1) // Tab 1 = Genehmigt
        } else if (mode == 'Kreis') {
          if (user.ka()) {
            commit('SET_CURRENT_TAB', 0)
          } else if (user.kv()) {
            commit('SET_CURRENT_TAB', 1)
          } else if (user.kk()) {
            commit('SET_CURRENT_TAB', 2)
          }
        }
      }

      // RefIds für user_filter vorbereiten (aber NICHT für Loader args)
      if (mode == 'FLVW' && user.abteilungsleiter() && !user.finanzen()) {
        const refIds = user.abteilungen.map(item => md5(item))
        if (state.ehrenamt && Array.isArray(state.ehrenamt)) {
          state.ehrenamt.forEach(item => {
            user.abteilungen.forEach(abteilung => {
              if (item.abteilungen?.includes(abteilung)) {
                refIds.push(item.id)
              }
            })
          })
        }
        state.user_filter = Object.assign({}, state.user_filter, { empfaenger: refIds });
      }

      // Loader OHNE args erstellen - die Filterung passiert komplett in loadAbrechnungen
      const abrechnungenLoader = new AbrechnungenLoader()
      const searchLoader = new AbrechnungenLoader()
      commit('SET_ABRECHNUNGEN_LOADER', abrechnungenLoader)
      commit('SET_SEARCH_LOADER', searchLoader)

      // Filter zurücksetzen und Abrechnungen laden
      commit('RESET_FILTER')
      await dispatch('loadAbrechnungen')
    },
    async loadHauptamt({ commit }) {
      const hauptamt = await getDocs(collection(getFirestore(), 'Hauptamt'))
      commit('RESET_HAUPTAMT')
      hauptamt.forEach(amt => {
        commit('ADD_HAUPTAMT', {
          id: amt.id,
          name: amt.data().name,
          ansprechpartner: amt.data().ansprechpartner
        })
      })
    },
    async loadEhrenamt({ commit }) {
      const ehrenamt = await getDocs(collection(getFirestore(), 'Ehrenamt'))
      commit('RESET_EHRENAMT')
      ehrenamt.forEach(amt => {
        commit('ADD_EHRENAMT', {
          id: amt.id,
          name: amt.data().name,
          abteilungen: amt.data().abteilungen || []
        })
      })
    },
    async loadAbrechnungen({ commit, state, getters }, user) {
      commit('SET_LOADING', true)
      
      if (!state.abrechnungenLoader) {
        commit('SET_LOADING', false)
        return
      }

      state.abrechnungenLoader.currentLimit = state.abrechnungenLoader.limit
      let allAbrechnungen = []

      if (state.mode == 'FLVW') {
        if (state.user.abteilungsleiter() && !state.user.finanzen()) {
          // Sammle alle refIds
          const refIds = state.user.abteilungen.map(item => md5(item))
          if (state.ehrenamt && Array.isArray(state.ehrenamt)) {
            state.ehrenamt.forEach(item => {
              state.user.abteilungen.forEach(abteilung => {
                if (item.abteilungen?.includes(abteilung)) {
                  refIds.push(item.id)
                }
              })
            })
          }

          // Berechne verfügbare Disjunktionen - OHNE Jahr-Filter in Chunks
          let usedDisjunctions = 1 // status filter
          
          // Abteilungs-Filter (falls vorhanden)
          if (state.filter.abteilung.type != 'Alle') {
            usedDisjunctions += 1
          }

          // Maximal verfügbare Disjunktionen für refIds (sehr konservativer Ansatz)
          // Firebase normalisiert intern, daher sehr kleine Chunks verwenden
          const maxRefIdsPerQuery = Math.max(1, Math.min(30 - usedDisjunctions - 15, 10))
          
          // Teile refIds in Chunks auf
          const chunks = []
          for (let i = 0; i < refIds.length; i += maxRefIdsPerQuery) {
            chunks.push(refIds.slice(i, i + maxRefIdsPerQuery))
          }

          // Führe für jeden Chunk eine separate Query aus
          for (let chunkIndex = 0; chunkIndex < chunks.length; chunkIndex++) {
            const chunk = chunks[chunkIndex]
            
            const args = [where('status', '==', getters.currentStatus)]
            
            // RefIds Filter
            if (chunk.length > 0) {
              args.push(where('empfaenger.refId', 'in', chunk))
            }

            // KEIN Jahr-Filter in den Chunks - wird später client-seitig gefiltert

            // Abteilungs-Filter
            if (state.filter.abteilung.type != 'Alle') {
              args.push(where('empfaenger.name', '==', state.filter.abteilung.name))
            }

            try {
              const chunkAbrechnungen = await state.abrechnungenLoader.load(state.selected_sort.value, state.user_filter, ...args)
              allAbrechnungen = allAbrechnungen.concat(chunkAbrechnungen)
            } catch (error) {
              console.error(`Error loading chunk ${chunkIndex + 1}:`, error)
            }
          }

          // Duplikate entfernen
          const uniqueAbrechnungen = allAbrechnungen.filter((abrechnung, index, self) => 
            index === self.findIndex(a => a.id === abrechnung.id)
          )
          
          // Client-seitige Jahr-Filterung (da Jahr-Filter zu viele Disjunktionen verursacht)
          let filteredAbrechnungen = uniqueAbrechnungen
          if (state.filter.jahr.length > 0) {
            const selectedYears = state.filter.jahr.map(jahr => parseInt(jahr))
            filteredAbrechnungen = uniqueAbrechnungen.filter(abrechnung => {
              // Prüfe ob eines der Tags mit den ausgewählten Jahren übereinstimmt
              return abrechnung.tags && abrechnung.tags.some(tag => selectedYears.includes(tag))
            })
          }
          
          commit('SET_CURRENT_ABRECHNUNGEN', filteredAbrechnungen)

        } else if (state.user.finanzen()) {
          // Normale Query für Finanzen-Benutzer
          const args = [
            where('status', '==', getters.currentStatus),
            where('empfaenger.type', 'in', ['Hauptamt', 'Gremium'])
          ]

          // Jahr-Filter
          if (state.filter.jahr.length > 0) {
            // Begrenze auf maximal 3 Jahre um Disjunktionen-Limit einzuhalten
            const limitedJahre = state.filter.jahr.slice(0, 3).map(jahr => parseInt(jahr))
            args.push(where('tags', 'array-contains-any', limitedJahre))
          }

          // Abteilungs-Filter
          if (state.filter.abteilung.type != 'Alle') {
            args.push(where('empfaenger.name', '==', state.filter.abteilung.name))
          }

          const abrechnungen = await state.abrechnungenLoader.load(state.selected_sort.value, state.user_filter, ...args)
          commit('SET_CURRENT_ABRECHNUNGEN', abrechnungen)
        }
      } else if (state.mode == 'Kreis' && state.user) {
        // Kreis-Modus Query
        const args = [where('status', '==', getters.currentStatus)]

        if (state.user.ka() && !state.user.kk() && !state.user.kv()) {
          const ausschussIds = state.user.ausschuesse.map(item => item.ausschussId)
          const kreisIds = state.user.ausschuesse.map(item => parseInt(item.kreisId))

          // Prüfe Disjunktionen für Kreis-Modus
          let totalIds = ausschussIds.length + kreisIds.length
          let jahreCount = state.filter.jahr.length > 0 ? state.filter.jahr.length : 0
          let ausschussFilter = state.filter.ausschuss.type == 'Kreis-Ausschuss' ? 1 : 0

          if (totalIds + jahreCount + ausschussFilter + 1 > 30) {
            // Begrenzen auf verfügbare Slots
            const maxIds = Math.max(1, 25 - jahreCount - ausschussFilter)
            const limitedAusschussIds = ausschussIds.slice(0, Math.floor(maxIds / 2))
            const limitedKreisIds = kreisIds.slice(0, Math.floor(maxIds / 2))
            
            args.push(where('empfaenger.ausschuss.refId', 'in', limitedAusschussIds))
            args.push(where('empfaenger.refId', 'in', limitedKreisIds))
          } else {
            args.push(where('empfaenger.ausschuss.refId', 'in', ausschussIds))
            args.push(where('empfaenger.refId', 'in', kreisIds))
          }
        } else {
          args.push(where('empfaenger.type', 'in', ['Kreis', 'Kreis-Ausschuss']))
          args.push(where('empfaenger.refId', '==', parseInt(state.user.kreis)))
        }

        // Jahr-Filter
        if (state.filter.jahr.length > 0) {
          // Begrenze auf maximal 3 Jahre um Disjunktionen-Limit einzuhalten
          const limitedJahre = state.filter.jahr.slice(0, 3).map(jahr => parseInt(jahr))
          args.push(where('tags', 'array-contains-any', limitedJahre))
        }

        // Ausschuss-Filter
        if (state.filter.ausschuss.type == 'Kreis-Ausschuss') {
          args.push(where('empfaenger.ausschuss.refId', '==', state.filter.ausschuss.refId))
        }

        const abrechnungen = await state.abrechnungenLoader.load(state.selected_sort.value, state.user_filter, ...args)
        commit('SET_CURRENT_ABRECHNUNGEN', abrechnungen)
      }

      commit('SET_LOADING', false)
    },

    async loadMoreAbrechnungen({ commit, state }) {
      if (!state.abrechnungenLoader) return

      commit('SET_LOADING', true)
      const moreAbrechnungen = await state.abrechnungenLoader.loadMore(state.selected_sort.value, state.user_filter)
      commit('ADD_MORE_ABRECHNUNGEN', moreAbrechnungen)
      commit('SET_LOADING', false)
    },

    async searchAbrechnungen({ state }, { vorname, nachname, jahr }) {
      if (!state.searchLoader) return []

      // Minimale Query nur mit Name-Filter - alles andere client-seitig
      const args = []
      
      if (vorname && nachname) {
        args.push(where('abrechnender.vorname', '==', vorname))
        args.push(where('abrechnender.nachname', '==', nachname))
      } else if (vorname) {
        args.push(where('abrechnender.vorname', '==', vorname))
      } else if (nachname) {
        args.push(where('abrechnender.nachname', '==', nachname))
      } else {
        throw new Error('Vorname oder Nachname muss angegeben werden')
      }

      // Lade alle Ergebnisse mit nur dem Namen-Filter
      let allResults = await state.searchLoader.load(3, state.user_filter, ...args)

      // Client-seitige Filterung nach Status
      const validStatus = ['Eingereicht', 'Offen', 'Genehmigt', 'Abgeschlossen']
      allResults = allResults.filter(abrechnung => validStatus.includes(abrechnung.status))

      // Client-seitige Filterung nach Jahr
      if (jahr && jahr.length > 0) {
        const selectedYears = jahr.map(j => parseInt(j))
        allResults = allResults.filter(abrechnung => {
          return abrechnung.tags && abrechnung.tags.some(tag => selectedYears.includes(tag))
        })
      }

      // Client-seitige Berechtigungsfilterung
      if (state.mode === 'FLVW') {
        if (state.user.abteilungsleiter() && !state.user.finanzen()) {
          // Sammle alle erlaubten refIds für diesen Abteilungsleiter
          const allowedRefIds = state.user.abteilungen.map(item => md5(item))
          if (state.ehrenamt && Array.isArray(state.ehrenamt)) {
            state.ehrenamt.forEach(item => {
              state.user.abteilungen.forEach(abteilung => {
                if (item.abteilungen?.includes(abteilung)) {
                  allowedRefIds.push(item.id)
                }
              })
            })
          }

          // Filtere auf erlaubte Empfänger (Hauptamt oder Gremium)
          allResults = allResults.filter(abrechnung => {
            const type = abrechnung.empfaenger?.type
            if (type !== 'Hauptamt' && type !== 'Gremium') return false
            return allowedRefIds.includes(abrechnung.empfaenger?.refId)
          })

        } else if (state.user.finanzen()) {
          // Finanzen darf alle FLVW-Abrechnungen sehen
          allResults = allResults.filter(abrechnung => {
            const type = abrechnung.empfaenger?.type
            return type === 'Hauptamt' || type === 'Gremium'
          })
        }

      } else if (state.mode === 'Kreis' && state.user) {
        if (state.user.ka() && !state.user.kk() && !state.user.kv()) {
          // Ausschussvorsitzender: nur seine Ausschüsse
          const allowedAusschussIds = state.user.ausschuesse.map(item => item.ausschussId)
          
          allResults = allResults.filter(abrechnung => {
            return allowedAusschussIds.includes(abrechnung.empfaenger?.ausschuss?.refId)
          })

        } else if (state.user.kv() || state.user.kk()) {
          // Kreisvorsitzender oder Kreiskassierer: alle Abrechnungen des Kreises
          const kreisId = parseInt(state.user.kreis)
          
          allResults = allResults.filter(abrechnung => {
            const type = abrechnung.empfaenger?.type
            if (type !== 'Kreis' && type !== 'Kreis-Ausschuss') return false
            return abrechnung.empfaenger?.refId === kreisId
          })
        }
      }

      return allResults
    },

    resetFilter({ commit, dispatch }) {
      commit('RESET_FILTER')
      return dispatch('loadAbrechnungen')
    },

    updateFilter({ commit, dispatch }, filter, user) {
      commit('SET_FILTER', filter)
      return dispatch('loadAbrechnungen', user)
    },

    updateTab({ commit, dispatch }, tab) {
      commit('SET_CURRENT_TAB', tab)
      return dispatch('loadAbrechnungen')
    },

    updateSort({ commit, dispatch }, sort) {
      commit('SET_SELECTED_SORT', sort)
      return dispatch('loadAbrechnungen')
    },

    setCurrentAbrechnung({ commit }, abrechnung) {
      commit('SET_CURRENT_ABRECHNUNG', abrechnung)
    }
  },
}

export default AbrechnungModule
